"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomViewStore_1 = require("@/room/room_view/roomViewStore");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const eggs_1 = require("@/common/eggs");
const material_ui_confirm_1 = require("material-ui-confirm");
const Button_1 = __importDefault(require("@mui/material/Button"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
function default_1({ isPreview }) {
    const isLoggedIn = (0, react_redux_1.useSelector)((state) => { var _a; return (_a = state.whoAmI) === null || _a === void 0 ? void 0 : _a.is_logged_in; });
    const userId = (0, react_redux_1.useSelector)((state) => { var _a; return (_a = state.whoAmI) === null || _a === void 0 ? void 0 : _a.id; });
    const channelId = (0, react_redux_1.useSelector)((state) => state.roomData.leader);
    const isSubscribe = (0, react_redux_1.useSelector)((state) => state.roomData.is_subscribe);
    const dispatch = (0, react_redux_1.useDispatch)();
    const onSubsChanged = (subscribed) => {
        dispatch((0, roomViewStore_1.setIsSubscribe)(subscribed));
    };
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const [pending, setPending] = (0, react_1.useState)(false);
    const onSubscribeClick = () => {
        if (!isPreview) {
            if (userId === channelId) {
                (0, eggs_1.preventMyself)({ confirm, message: t('자신을 구독하지 말아요') });
            }
            else {
                !pending &&
                    (0, functions_1.changeSubscribeState)({
                        isLoggedIn,
                        setPending,
                        channelId,
                        onSubsChanged,
                    });
            }
        }
    };
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const open = Boolean(anchorEl);
    const closeMenu = () => setAnchorEl(null);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ sx: {
                    columnGap: '4px',
                    minWidth: '80px',
                    height: '32px',
                    p: '0 12px',
                    borderRadius: '8px',
                    border: open || !isSubscribe ? 0 : '1px solid var(--primary-dark)',
                    fontWeight: isSubscribe ? 'normal' : 'bold',
                    color: open ? 'var(--gray-80)' : isSubscribe ? 'var(--primary-dark)' : 'var(--white)',
                    bgcolor: open
                        ? 'var(--gray-30) !important'
                        : isSubscribe
                            ? 'var(--white) !important'
                            : 'var(--primary-main) !important',
                }, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, onClick: event => (isSubscribe ? setAnchorEl(event.currentTarget) : onSubscribeClick()) }, { children: pending ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 16, color: isSubscribe ? 'primary' : 'info', thickness: 4 })) : isSubscribe ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(svgs_1.CheckIconSvg, { css: {
                                width: '18px',
                                height: '18px',
                                path: { stroke: open ? 'var(--gray-80)' : 'var(--primary-dark)' },
                            } }), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle4" }, { children: t('구독중') }))] })) : ((0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "subtitle4" }, { children: ["+ ", t('V-구독')] }))) })), (0, jsx_runtime_1.jsx)(Menu_1.default, Object.assign({ anchorEl: anchorEl, autoFocus: false, open: open, onClose: closeMenu, slotProps: { paper: { sx: { borderRadius: '8px' } } }, transformOrigin: { horizontal: 'right', vertical: 'top' }, anchorOrigin: { horizontal: 'right', vertical: 'bottom' } }, { children: (0, jsx_runtime_1.jsx)(MenuItem_1.default, Object.assign({ sx: {
                        minHeight: '40px !important',
                        p: '0 12px',
                        borderRadius: '8px',
                    }, onClick: () => {
                        onSubscribeClick();
                        closeMenu();
                    } }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 error-main", css: { wordBreak: 'break-word' } }, { children: t('구독 취소하기') })) })) }))] }));
}
exports.default = default_1;
